import { Statuses } from '../auto-pricing/statuses';
const warnAboutMissingLogger = () => console.warn('`whatsapp module` is missing `logger` dependency');
export function createWhatsapp(_ref) {
  let {
    whatsappService,
    logger,
    apmLogger
  } = _ref;
  function isValidStatus(status) {
    return Object.values(Statuses).includes(status);
  }
  const checkStatus = status => {
    if (!isValidStatus(status)) {
      throw new Error("Unknown whatsapp status: " + status + ". Valid values are: " + Object.values(Statuses));
    }
  };
  function subscribe(_ref2) {
    let {
      carleadHash,
      onMessageHandler,
      onErrorHandler
    } = _ref2;
    const onMessage = data => {
      checkStatus(data.status);
      onMessageHandler(carleadHash, data, whatsappService);
    };
    const onError = err => {
      apmLogger.error(err);
      if (logger !== null && logger !== void 0 && logger.error) {
        logger.error({
          error: err,
          message: '[WHATSAPP] Subscription error'
        });
      } else {
        console.error(err);
        warnAboutMissingLogger();
      }
      onErrorHandler(err, carleadHash);
    };
    try {
      whatsappService.init(carleadHash);
      whatsappService.listen(onMessage, onError);
    } catch (err) {
      onError(err);
    }
  }
  return {
    subscribe
  };
}